var _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-214--inject-513"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-214--inject-513",
    cx: 250,
    cy: 410.07,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-513"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.4,341.53H45.31a5.72,5.72,0,0,1-5.71-5.71V64.39a5.72,5.72,0,0,1,5.71-5.66H238.4a5.71,5.71,0,0,1,5.7,5.71h0V335.82A5.71,5.71,0,0,1,238.4,341.53ZM45.31,58.93a5.47,5.47,0,0,0-5.46,5.46V335.82a5.47,5.47,0,0,0,5.46,5.46H238.4a5.46,5.46,0,0,0,5.45-5.46V64.39a5.46,5.46,0,0,0-5.45-5.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,341.53H261.6a5.71,5.71,0,0,1-5.7-5.71V64.39a5.71,5.71,0,0,1,5.7-5.66H454.7a5.71,5.71,0,0,1,5.7,5.66V335.82A5.71,5.71,0,0,1,454.7,341.53ZM261.6,58.93a5.46,5.46,0,0,0-5.45,5.46V335.82a5.46,5.46,0,0,0,5.45,5.46H454.7a5.48,5.48,0,0,0,5.47-5.46V64.39a5.48,5.48,0,0,0-5.47-5.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.79,
    y: 392.21,
    width: 41.21,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.67,
    y: 390.21,
    width: 41.33,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.78,
    y: 390.21,
    width: 10,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.58,
    y: 398.75,
    width: 46.25,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.2,
    y: 392.08,
    width: 21.6,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.7,
    y: 392.08,
    width: 27.93,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.89,
    y: 396.31,
    width: 62.44,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.83,
    y: 114.23,
    width: 47.61,
    height: 33.27,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.83,
    y: 114.23,
    width: 21.47,
    height: 33.27,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.55,118.74a7.09,7.09,0,1,1-7.09,7.09A7.09,7.09,0,0,1,375.55,118.74Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,139.66a3.46,3.46,0,1,1-3.46-3.46h0A3.45,3.45,0,0,1,379,139.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.5,
    cy: 126.31,
    r: 2.02,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.21,
    y: 102.31,
    width: 20.59,
    height: 45.2,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.23,
    y: 102.31,
    width: 27.32,
    height: 45.2,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.43,116.66a2.86,2.86,0,1,1-2.85,2.85A2.86,2.86,0,0,1,300.43,116.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.43,112.21a1.43,1.43,0,1,1-1.43,1.43A1.43,1.43,0,0,1,300.43,112.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.43,107.89a1.43,1.43,0,1,1-1.43,1.43A1.43,1.43,0,0,1,300.43,107.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.67,
    y: 127.66,
    width: 46.4,
    height: 0.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.67,
    y: 131.67,
    width: 46.4,
    height: 0.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.67,
    y: 135.68,
    width: 46.4,
    height: 0.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.67,
    y: 139.69,
    width: 46.4,
    height: 0.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.67,
    y: 143.7,
    width: 46.4,
    height: 0.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.96,
    y: 128.88,
    width: 1.96,
    height: 1.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.96,
    y: 133.1,
    width: 1.96,
    height: 1.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.96,
    y: 136.9,
    width: 1.96,
    height: 1.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.96,
    y: 141,
    width: 1.96,
    height: 1.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.96,
    y: 144.98,
    width: 1.96,
    height: 1.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.87,192h-1V153.71a7.81,7.81,0,0,1,7.8-7.8h33v1h-33a6.81,6.81,0,0,0-6.8,6.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.87,192.07h-1V153.43a9.47,9.47,0,0,1,9.46-9.46h33.34v1H257.33a8.47,8.47,0,0,0-8.46,8.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.06,
    y: 96,
    width: 31.31,
    height: 33.33,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.37,
    y: 96,
    width: 8.02,
    height: 33.33,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.85,
    y: 90.86,
    width: 23.52,
    height: 38.47,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.36,
    y: 90.86,
    width: 6.8,
    height: 38.47,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.61,
    y: 96,
    width: 19.83,
    height: 33.33,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.44,
    y: 96,
    width: 4.53,
    height: 33.33,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 101.64,
    width: 26.01,
    height: 27.69,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.21,
    y: 101.64,
    width: 6.66,
    height: 27.69,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.38,
    y: 97.37,
    width: 19.54,
    height: 31.96,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.91,
    y: 97.37,
    width: 5.65,
    height: 31.96,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.18,
    y: 101.64,
    width: 18.98,
    height: 27.69,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.17,
    y: 101.64,
    width: 3.76,
    height: 27.69,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 129.31,
    width: 204,
    height: 9.65,
    transform: "translate(284 268.27) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.61 139.19 87.89 139.19 79.67 151.6 76.61 151.6 76.61 139.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.98,
    y: 139.19,
    width: 1.63,
    height: 12.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.31 139.19 214.6 139.19 206.38 151.6 203.31 151.6 203.31 139.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.69,
    y: 139.19,
    width: 1.63,
    height: 12.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.23,
    y: 147.51,
    width: 204,
    height: 9.65,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.63 169.79 420.56 169.79 412.34 157.38 423.63 157.38 423.63 169.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.63,
    y: 157.38,
    width: 1.63,
    height: 12.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.92 169.79 293.85 169.79 285.63 157.38 296.92 157.38 296.92 169.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.92,
    y: 157.38,
    width: 1.63,
    height: 12.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.45,109.89a14.43,14.43,0,0,0-.63-4.23l3.71-3.26-2.33-4.05-4.68,1.59a14.6,14.6,0,0,0-7.33-4.24l-1-4.84h-4.67l-1,4.84a14.57,14.57,0,0,0-7.32,4.24l-4.69-1.59-2.33,4.05,3.71,3.26a14.52,14.52,0,0,0,0,8.46l-3.71,3.26,2.33,4.05,4.69-1.59a14.57,14.57,0,0,0,7.32,4.24l1,4.84h4.67l1-4.84a14.6,14.6,0,0,0,7.33-4.24l4.68,1.59,2.33-4.05-3.71-3.26A14.43,14.43,0,0,0,197.45,109.89Zm-14.56,7.86a7.57,7.57,0,1,1,7.57-7.57A7.57,7.57,0,0,1,182.89,117.75Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.71,112.34a9.24,9.24,0,0,0-1.8-2.16l1-3.11-2.7-1.47-2.09,2.5a9.51,9.51,0,0,0-5.56.14l-2.21-2.38-2.63,1.6,1.12,3.05a9.67,9.67,0,0,0-2.66,4.9l-3.17.72.08,3.07,3.21.56a9.63,9.63,0,0,0,2.9,4.75l-1,3.11,2.7,1.47,2.09-2.5a9.71,9.71,0,0,0,5.57-.14l2.21,2.38,2.62-1.6-1.12-3.06a9.64,9.64,0,0,0,2.66-4.89l3.17-.72-.08-3.08-3.2-.55A9.22,9.22,0,0,0,222.71,112.34Zm-5.47,9.42a5,5,0,1,1,1.65-6.86A5,5,0,0,1,217.24,121.76Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Group--inject-513"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.56,
    y: 273.12,
    width: 407.62,
    height: 5.13,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.84 276.8 70.84 399.14 74.02 399.14 78.02 276.8 70.84 276.8",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.38 280.8 108.38 394.14 111.56 394.14 115.56 280.8 108.38 280.8",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.38 280.8 108.38 394.14 111.56 394.14 115.56 280.8 108.38 280.8",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.35 276.8 431.35 399.14 428.18 399.14 424.17 276.8 431.35 276.8",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.81 280.8 393.81 394.14 390.63 394.14 386.63 280.8 393.81 280.8",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.81 280.8 393.81 394.14 390.63 394.14 386.63 280.8 393.81 280.8",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.6 283.74 63.34 283.74 55.04 278.25 446.9 278.25 438.6 283.74",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.6 283.74 63.34 283.74 55.04 278.25 446.9 278.25 438.6 283.74",
    style: {
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Beverages--inject-513"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.35,257.39v4a2.51,2.51,0,0,0,.73,1.77l3.17,3.17a2.52,2.52,0,0,0,1,.61,8.14,8.14,0,0,0,7.38,4.71h1.19A8.13,8.13,0,0,0,95,263.47v-9.33H77.52v.76H75.85A2.5,2.5,0,0,0,73.35,257.39Zm2,0a.49.49,0,0,1,.5-.49h1.67v6.57c0,.09,0,.18,0,.27l-2-2a.47.47,0,0,1-.15-.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.35,257.39v4a2.51,2.51,0,0,0,.73,1.77l3.17,3.17a2.52,2.52,0,0,0,1,.61,8.14,8.14,0,0,0,7.38,4.71h1.19A8.13,8.13,0,0,0,95,263.47v-9.33H77.52v.76H75.85A2.5,2.5,0,0,0,73.35,257.39Zm2,0a.49.49,0,0,1,.5-.49h1.67v6.57c0,.09,0,.18,0,.27l-2-2a.47.47,0,0,1-.15-.35Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.14,273H74a4.63,4.63,0,0,1-3-1.48H102.1A4.6,4.6,0,0,1,99.14,273Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.14,273H74a4.63,4.63,0,0,1-3-1.48H102.1A4.6,4.6,0,0,1,99.14,273Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.36,260.76c-.13-4-3.15-4.94-7.09-5.39v-1.45a.64.64,0,0,0-.65-.62H416a.64.64,0,0,0-.66.62h0v18.91h14.94v-2.07C434.22,270.32,437.24,264.74,437.36,260.76Zm-7.09,7.56v-10.5c2.9.42,4.9.82,4.47,3.72C434.4,263.86,432.58,268,430.27,268.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.36,260.76c-.13-4-3.15-4.94-7.09-5.39v-1.45a.64.64,0,0,0-.65-.62H416a.64.64,0,0,0-.66.62h0v18.91h14.94v-2.07C434.22,270.32,437.24,264.74,437.36,260.76Zm-7.09,7.56v-10.5c2.9.42,4.9.82,4.47,3.72C434.4,263.86,432.58,268,430.27,268.32Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-513"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.1,
    y: 248.73,
    width: 11.79,
    height: 23.95,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.1,
    y: 248.73,
    width: 11.79,
    height: 23.95,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.22 273.11 238.88 273.11 244.33 268.32 255.77 268.32 261.22 273.11",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.22 273.11 238.88 273.11 244.33 268.32 255.77 268.32 261.22 273.11",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.33 265.36 254.49 265.36 264.58 273.14 320.41 273.14 310.33 265.36",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.33 265.36 254.49 265.36 264.58 273.14 320.41 273.14 310.33 265.36",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.78 273.14 254.49 265.36 264.58 273.14 255.78 273.14",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.78 273.14 254.49 265.36 264.58 273.14 255.78 273.14",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.97,
    y: 192.04,
    width: 105.49,
    height: 66.18,
    rx: 1.93,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.8,
    y: 196.18,
    width: 97.72,
    height: 57.67,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.1,
    y: 208.04,
    width: 49.31,
    height: 33.95,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.1,
    y: 208.04,
    width: 49.31,
    height: 3.11,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.14,226.82l8.06,4.46a2.6,2.6,0,0,1,.81.61,1.14,1.14,0,0,1,.2.68,1.27,1.27,0,0,1-.38.91,1.2,1.2,0,0,1-.87.38,2.23,2.23,0,0,1-1-.37l-10.4-5.78a1,1,0,0,1,0-1.79l10.4-5.78a2.27,2.27,0,0,1,1-.35,1.19,1.19,0,0,1,.88.37,1.23,1.23,0,0,1,.38.9,1.12,1.12,0,0,1-.2.68,2.6,2.6,0,0,1-.81.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.88,218.49l-8,17.19a2.65,2.65,0,0,1-.55.84,1.18,1.18,0,0,1-.76.25,1.21,1.21,0,0,1-.88-.36,1.13,1.13,0,0,1-.38-.83,2.51,2.51,0,0,1,.3-1l8-17.18a2.74,2.74,0,0,1,.53-.83,1.23,1.23,0,0,1,.77-.26,1.19,1.19,0,0,1,.87.36,1.12,1.12,0,0,1,.36.82A2.45,2.45,0,0,1,275.88,218.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.91,226.82l-8.06-4.47a2.87,2.87,0,0,1-.81-.61,1.12,1.12,0,0,1-.2-.68,1.23,1.23,0,0,1,.38-.9,1.22,1.22,0,0,1,.89-.37,2.32,2.32,0,0,1,1,.35l10.4,5.78a1,1,0,0,1,0,1.79l-10.4,5.78a2.29,2.29,0,0,1-1,.37,1.2,1.2,0,0,1-.9-.39,1.26,1.26,0,0,1-.37-.9,1.14,1.14,0,0,1,.2-.68,2.87,2.87,0,0,1,.81-.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.81,
    y: 201.5,
    width: 3.34,
    height: 3.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.81,
    y: 210.15,
    width: 3.34,
    height: 3.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.81,
    y: 218.79,
    width: 3.34,
    height: 3.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.81,
    y: 227.43,
    width: 3.34,
    height: 3.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.81,
    y: 236.07,
    width: 3.34,
    height: 3.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.81,
    y: 244.71,
    width: 3.34,
    height: 3.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.32,
    y: 202.26,
    width: 13.31,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.42,
    y: 210.92,
    width: 4.74,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.05,
    y: 220.64,
    width: 4.74,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.42,
    y: 228.35,
    width: 4.74,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 228.35,
    width: 4.74,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 220.64,
    width: 12.11,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.31,
    y: 228.35,
    width: 7.97,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.28,
    y: 246.88,
    width: 4.74,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.12,
    y: 246.88,
    width: 4.74,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.17,
    y: 246.88,
    width: 2.65,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.53,
    y: 210.92,
    width: 14.75,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.25,
    y: 237.38,
    width: 4.74,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.58,
    y: 237.38,
    width: 2.74,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.41,
    y: 237.38,
    width: 7.74,
    height: 1,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-code--inject-513"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.44,164.5c-.25,12.1-12.82,22.25-28.09,22.65a32.37,32.37,0,0,1-13.68-2.53c-1.54,3.8-4.78,7.06-14.07,8.52,9.69-7.49,4.39-13.83,2.18-19.4h0a17.6,17.6,0,0,1-1.67-7.78c.25-12.11,12.82-22.24,28.09-22.65S241.68,152.4,241.44,164.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.79,
    y: 151.83,
    width: 13.31,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.89,
    y: 160.5,
    width: 4.74,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.52,
    y: 170.22,
    width: 4.74,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.89,
    y: 177.93,
    width: 4.74,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.73,
    y: 177.93,
    width: 4.74,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.73,
    y: 170.22,
    width: 12.11,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.78,
    y: 177.93,
    width: 7.97,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.01,
    y: 160.5,
    width: 14.75,
    height: 1,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-513"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "299.17 393.75 291.88 391.57 293.58 373.7 300.87 375.88 299.17 393.75",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.47 371.84 294.18 369.67 293.23 379.68 300.6 381.05 301.47 371.84",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.32,283.38s-50.13,4.23-48.9,26c1,17.82,3.65,13-1.54,66l12.61.7s12.83-43.34,11.1-60.56c14.13,0,46.48,1.24,51.18-11.51a56.76,56.76,0,0,0,3.35-20.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.49 378.48 290.01 375.66 290.28 368.37 307.34 372.16 306.49 378.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.13,388.57l8.42,1.67a.63.63,0,0,1,.48.7l-.7,8a1.42,1.42,0,0,1-1.54,1.32c-2.92-.64-4.3-1.11-8-1.85-2.28-.45-7.49-1.54-10.66-1.9s-2.79-4.06-1.42-4.25c6.16-.81,9.66-1.81,12.05-3.35A1.87,1.87,0,0,1,291.13,388.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.35,390a9.54,9.54,0,0,0,2,.06.15.15,0,0,0,.15-.11.21.21,0,0,0,0-.19c-.21-.21-2.1-2-3.07-1.8a.62.62,0,0,0-.49.42,1,1,0,0,0,.06,1A2,2,0,0,0,287.35,390Zm1.61-.27c-1.39,0-2.37-.16-2.66-.57a.61.61,0,0,1,0-.64.32.32,0,0,1,.23-.22C287,388.2,288.18,389,289,389.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.36,390.07h.08a.2.2,0,0,0,.12-.13c0-.09.55-2.22-.09-3.07a.85.85,0,0,0-.7-.37.67.67,0,0,0-.72.42c-.31.79.55,2.54,1.22,3.11A.11.11,0,0,0,289.36,390.07Zm-.52-3.21a.59.59,0,0,1,.35.22,4,4,0,0,1,.09,2.46,3.55,3.55,0,0,1-.9-2.49c0-.1.11-.21.37-.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.67 396.53 259.73 393.41 264.53 376.29 271.47 379.41 266.67 396.53",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.64 375 265.7 371.88 263.23 380.71 270.17 383.83 272.64 375",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.4,283.38c-.33,0-56.2,5.75-56.27,24.7-.12,31.34-9.07,67.26-9.07,67.26l11,5.47s19.23-38.94,18.94-63.37c15.37-4.41,55.13,3,59.83-9.74,3.85-10.42,1.77-24.32,1.77-24.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.86 382.4 260.06 375.74 261.25 369.68 276.86 375.07 274.86 382.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.42,387.66l8.44,1.75a.7.7,0,0,1,.47.78l-.66,8.75c-.12.95-.8,1.6-1.53,1.45h0c-2.92-.67-4.3-1.19-8-2-2.28-.46-8.49-2-11.62-2.79s-2.43-4.8-1-4.83c6.19-.09,10.2-1.1,12.58-2.83A1.68,1.68,0,0,1,260.42,387.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,389.55a9.89,9.89,0,0,0,1.65-1.14.2.2,0,0,0,.06-.19.17.17,0,0,0-.15-.12c-.29,0-2.87-.38-3.54.37a.68.68,0,0,0-.14.63,1,1,0,0,0,.64.77A2.09,2.09,0,0,0,257,389.55Zm1.13-1.17c-1.09.85-2,1.26-2.47,1.12a.67.67,0,0,1-.39-.53.3.3,0,0,1,.07-.3C255.64,388.31,257,388.28,258.08,388.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.6,388.41l.07-.05a.15.15,0,0,0,0-.17c-.05-.07-.88-2.12-1.89-2.43a.89.89,0,0,0-.78.12.67.67,0,0,0-.33.77c.21.83,1.94,1.72,2.83,1.78Zm-2.33-2.28a.52.52,0,0,1,.42,0,4,4,0,0,1,1.54,1.93,3.56,3.56,0,0,1-2.21-1.47c-.06-.08,0-.24.18-.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.38,222.92c1.47,3.16,2.68,6.2,3.89,9.36s2.28,6.32,3.27,9.56,1.85,6.56,2.54,10a52.16,52.16,0,0,1,1.12,10.87,22.32,22.32,0,0,1-.95,6.33,14.46,14.46,0,0,1-1.67,3.56,12.48,12.48,0,0,1-1.43,1.74l-.43.42c-.24.2-.5.42-.75.59a8.31,8.31,0,0,1-1.34.74,11.8,11.8,0,0,1-2.16.69,15.42,15.42,0,0,1-1.77.26,25.86,25.86,0,0,1-3.05,0,44,44,0,0,1-5.38-.6,102.24,102.24,0,0,1-19.41-5.56l1.45-5.51c6.35.76,12.83,1.57,18.94,1.85,1.52,0,3,.07,4.38,0a14.3,14.3,0,0,0,1.83-.23c.5-.09.93-.27.78-.26a.92.92,0,0,0-.28.14,1.46,1.46,0,0,0-.28.21h0a1.56,1.56,0,0,0,.09-.17,4.91,4.91,0,0,0,.3-.89,14.4,14.4,0,0,0,.27-3.34,45,45,0,0,0-1.27-8.49c-.68-3-1.56-5.92-2.52-8.89s-2-5.94-3.14-8.9-2.34-5.93-3.52-8.72Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.07,266.87l-6.63-3.73-3.33,7.18s7.75,3.23,9.38,1.21Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.07 264.5 308.04 269.3 313.11 270.27 316.44 263.09 311.07 264.5",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92,228.62c-1.27,3.19-2.6,6.24-4,9.33s-2.8,6.13-4.28,9.17a176.53,176.53,0,0,1-10,18c-1,1.48-2,2.95-3.12,4.42-.56.74-1.18,1.47-1.84,2.22-.36.38-.65.73-1.07,1.12l-.6.58-.34.32a8.52,8.52,0,0,1-3.28,1.74,14.56,14.56,0,0,1-1.94.41,20.41,20.41,0,0,1-3.22.13,41.09,41.09,0,0,1-5.54-.55,101.83,101.83,0,0,1-19.82-5.62l1.46-5.52c6.47.78,13.08,1.61,19.3,1.87a43.1,43.1,0,0,0,4.4-.06,11.59,11.59,0,0,0,1.75-.28,2.7,2.7,0,0,0,.54-.2c.06,0,0-.07-.27.1a1.05,1.05,0,0,0-.27.2l.1-.12.28-.31c.18-.18.4-.48.61-.72.41-.52.83-1.08,1.25-1.69.83-1.19,1.64-2.51,2.44-3.85,1.6-2.68,3.09-5.53,4.55-8.41s2.86-5.82,4.24-8.78c2.75-5.9,5.44-12,8-17.9Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.17,265.81,269.53,262l-3.33,7.18s7.75,3.24,9.39,1.22Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.17 263.45 261.13 268.24 266.2 269.21 269.53 262.03 264.17 263.45",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.09,193.14l-4.24,4.91-6.47,6.69.49,1.21a12.07,12.07,0,0,1,.86,3.88c.15,2.68-.11,4.95-4.34,6.77,0,0-4.44,5.8,6.12,4.19s12.15-7.09,12.15-7.09C348,210.37,347.72,199.3,348.09,193.14Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.56,187.6c0,.66-.33,1.22-.77,1.24s-.79-.5-.8-1.16.34-1.22.77-1.24S326.55,186.94,326.56,187.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.77,185.14a.38.38,0,0,1-.32-.18,3.26,3.26,0,0,0-2.42-1.54.4.4,0,0,1-.38-.4.38.38,0,0,1,.4-.38h0a4,4,0,0,1,3.06,1.9.4.4,0,0,1-.12.54A.46.46,0,0,1,328.77,185.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.32,188a21.42,21.42,0,0,1-2.3,5.12,3.2,3.2,0,0,0,2.72.2Z",
    style: {
      fill: "#630f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.69,184.27c-.39,8.16-.21,13-4.26,17.32a10.63,10.63,0,0,1-18.22-4.71c-1.84-7.23-.88-19.36,7-23a10.74,10.74,0,0,1,15.48,10.39Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.39,187a30.22,30.22,0,0,1-5.3,9.5l-10.62,2s-8.39-3.51-6.15-9.29c-1.42-1.2-.89-4.91.11-6.95a4.33,4.33,0,0,0,5.67-.15,3.88,3.88,0,0,0,6.15.51,4.1,4.1,0,0,0,6.46-1,3.67,3.67,0,0,0,4.28-.28l.15-.14A14.6,14.6,0,0,1,352.39,187Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.39,187a30.22,30.22,0,0,1-5.3,9.5l-10.62,2s-8.39-3.51-6.15-9.29c-1.42-1.2-.89-4.91.11-6.95a4.33,4.33,0,0,0,5.67-.15,3.88,3.88,0,0,0,6.15.51,4.1,4.1,0,0,0,6.46-1,3.67,3.67,0,0,0,4.28-.28l.15-.14A14.6,14.6,0,0,1,352.39,187Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.92,177.1a3.69,3.69,0,0,1-.78,4.05l-.15.14a3.67,3.67,0,0,1-4.28.28,4.1,4.1,0,0,1-6.46,1,3.88,3.88,0,0,1-6.15-.51,4.33,4.33,0,0,1-5.67.15,3.45,3.45,0,0,1-1-1.24,2.33,2.33,0,0,1-.14-.33,2.37,2.37,0,0,1-.28.27,3.09,3.09,0,0,1-3.56.21,3,3,0,0,1-1.28-2.69,2.77,2.77,0,0,1,.11-.64,1.73,1.73,0,0,1-.3.41,2.5,2.5,0,0,1-3.56-.09,3.09,3.09,0,0,1,1-4.36,3.68,3.68,0,0,1,1.88-.5,4.82,4.82,0,0,1,2.87,1,3,3,0,0,1,4.74-3.53A2.61,2.61,0,0,1,332,168c1.38-.8,3.68-.11,4.8,1.23,0,0,1.54-3.72,4.2-3.3.58.08,3.31,1.29,3.24,2.27a.41.41,0,0,1,0,.19,1.59,1.59,0,0,1,.13-.22,3,3,0,0,1,2.56-1.21,8.59,8.59,0,0,1,3.08.82c2.07.85,4.27,1.8,5.47,3.69S356.07,176.5,353.92,177.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,190a9.65,9.65,0,0,1-2.64,5.34c-1.81,1.73-3.35,0-3.37-2.63,0-2.38.89-6.15,3-6.85S335.4,187.37,335,190Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,216.54c-.75-2-4.25-4-6.4-4h-1.42a77.68,77.68,0,0,0-8.57.55,152.67,152.67,0,0,0-17,2.86c-2.58.68-5.07,1.54-7.05,2.28-2.52,1-4,1.67-4,1.67s2.76,18.38,4.19,36.64c.79,10.17.46,20.26.72,27.2h42.66c1.47-8.34,1.24-15.61,1.36-30.67C371.55,244,370.08,224.77,367,216.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.82,246.34c.32,3.83.65,7.85,1,11.87,5-7.3,7.76-27.27,7.76-27.27Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.14,221.24c-6.11,3.44-12.1,21-12.1,21l14,10.55c5.34-5.05,13.15-17.58,14-22.59C337.4,222.56,329.93,215.76,320.14,221.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.06,400.44a4.35,4.35,0,1,1-4.35-4.35,4.35,4.35,0,0,1,4.35,4.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,400.44a4.35,4.35,0,1,0,4.35-4.35,4.35,4.35,0,0,0-4.35,4.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.27,399a4.35,4.35,0,1,0,4.35-4.35,4.35,4.35,0,0,0-4.35,4.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.27,393.68v-8.41H326.81a38.86,38.86,0,0,0-7.29.68l-23.2,4.5a2.11,2.11,0,0,0,.47,4.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.27,393.68v-8.41h12.47A38.71,38.71,0,0,1,359,386l26.08,4.16a2.11,2.11,0,0,1-.47,4.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.55,
    y: 346.77,
    width: 15.43,
    height: 38.51,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.77,
    y: 328.85,
    width: 11,
    height: 17.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.77 334.11 344.77 336.88 344.77 328.85 333.77 328.85 333.77 334.11",
    style: {
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.12,
    y: 288.33,
    width: 5.59,
    height: 23.85,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.74,328.85V225.16a13.58,13.58,0,0,1,4.65-10.24l7.39-6.47a13.58,13.58,0,0,1,9-3.37h26.69L392.49,219V328.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,308.79h60.9v20.06H282.07a7.21,7.21,0,0,1-6.2-10.87h0A18.7,18.7,0,0,1,292,308.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.49,219V328.85H282.07a7.21,7.21,0,0,1-6.2-10.87A18.71,18.71,0,0,1,292,308.79h30.67a9.11,9.11,0,0,0,9.11-9.11V225.16a13.58,13.58,0,0,1,4.65-10.24l7.39-6.47a13.58,13.58,0,0,1,9-3.37h26.69Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.62,328.85V225.16a13.62,13.62,0,0,1,4.65-10.24l7.39-6.47a13.58,13.58,0,0,1,9-3.37h20.81a13.59,13.59,0,0,1,9.92,4.29l5.32,5.65a13.64,13.64,0,0,1,3.69,9.33v94.11A10.38,10.38,0,0,1,391,328.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.62,328.85V225.16a13.62,13.62,0,0,1,4.65-10.24l7.39-6.47a13.58,13.58,0,0,1,9-3.37h20.81a13.59,13.59,0,0,1,9.92,4.29l5.32,5.65a13.64,13.64,0,0,1,3.69,9.33v94.11A10.38,10.38,0,0,1,391,328.85Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.9,295.61a57.58,57.58,0,0,0-38,0,5.42,5.42,0,0,1-6.69-2.55h0c-1.14-2.41.39-5.53,3.49-6.62a67.27,67.27,0,0,1,44.38,0c3.1,1.08,4.63,4.21,3.49,6.62h0A5.42,5.42,0,0,1,319.9,295.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.9,295.61a57.58,57.58,0,0,0-38,0,5.42,5.42,0,0,1-6.69-2.55h0c-1.14-2.41.39-5.53,3.49-6.62a67.27,67.27,0,0,1,44.38,0c3.1,1.08,4.63,4.21,3.49,6.62h0A5.42,5.42,0,0,1,319.9,295.61Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-513"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.49,196.39c-.21.59-.06,1.18.33,1.31s.87-.23,1.07-.82.06-1.19-.32-1.32S164.7,195.79,164.49,196.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.38,197a22.83,22.83,0,0,0,1.07,6.06,3.66,3.66,0,0,1-3-.46Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.53,192.37a.3.3,0,0,0,.23,0,3,3,0,0,1,2.63.4.37.37,0,0,0,.52-.08.38.38,0,0,0,0-.48,3.68,3.68,0,0,0-3.32-.55.38.38,0,0,0-.23.47.35.35,0,0,0,.23.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.56,198.57c1.12,5.69,2.23,16.12-1.75,19.92,0,0,1.56,5.77,12.14,5.77,11.63,0,5.56-5.77,5.56-5.77-6.35-1.52-5.33-6.23-4.22-10.65Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.15,188.25c-2.08,7.44-3.68,11.69-1.3,16.7,3.57,7.55,16.05,8.53,19.45-.11,2.59-8,5.15-16.37-1-21.74a10.55,10.55,0,0,0-17.18,5.15Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.09,190.73c-.54-2.74-.68-5.74.69-8.18s4.68-3.93,7.09-2.51a11.7,11.7,0,1,1,16.59,15.05c.55-2.05,1.11-4.09,1.66-6.14a11.91,11.91,0,0,1-4.26,7.25l1-6.13a9.37,9.37,0,0,1-4.54,7.05l1.17-4.29a37.12,37.12,0,0,1-2.26,5.74c-1,1.15-1.64,8.67-5.08,8.91C137.33,209.83,138.35,197.13,137.09,190.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,194.29a8.81,8.81,0,0,0,1.22,5.47c1.33,2.14,3.28,1.32,4-.87.64-2,.71-5.45-1.14-6.84S153.28,192,153,194.29Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.81,266.37c-1.27-.42-7.22-3.48-8.17-2.93,2.75-7,4.46-8.09,5.71-12.55a6.84,6.84,0,0,0-1.33-6.5c-1.76-2.36-2.37-3.55-5.29-3.26-4,6.72-9.09,15-11.07,22.59-.67,2.55-1.15,4.49.37,6.65,1.34,1.9,3.81,2.66,6.13,2.87,5.57.5,13.84-.52,13.73-3.83C124.83,267.32,124.81,266.37,124.81,266.37Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.87,266.12l4.72-1.53-.42,8.53s-3.78.13-5.8-2.4Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.49 264.45 133.82 271.49 128.17 273.12 128.59 264.59 134.49 264.45",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.61,272.18S182,267,173.38,250c-1.28-2.38-2.5-4.79-3.68-7.21s-2.3-4.84-3.38-7.41l10.22-4.4c2.1,4.58,5.38,9.31,7.7,13.86s7.79,15.33,8.48,16.33c.34.52.71.95,1.06,1.43l.53.7-6.59,7.62Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.26,239l-2-2.44-.94-3.65,6.17-5.73A26.88,26.88,0,0,1,203,231a2,2,0,0,1,.22,1l-.25,6.43Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.36 228.97 198.97 224.78 200.43 227.23 194.27 232.93 194.36 228.97",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.35,237.24c.16-.69.3.66.76.12,1.36-1.64,3.34-1.81,4.52,0s.17,19.62-1.71,25.21c-1.25,3.71-1.92,6.67-5.12,8.93a7.8,7.8,0,0,1-4.5,1.62,4.27,4.27,0,0,1-3.9-2.42c-1-2.33,2.58-10.73,3.84-13.44C195.19,248.73,195.46,245.3,197.35,237.24Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.12,236.47l8.17-.08a7.91,7.91,0,0,0,3.42-.54,6.21,6.21,0,0,0,2.79-3.49c1.16-3,1.26-6.22,1.71-9.36s1.41-6.44,3.79-8.55c-4.34.58-12-.78-15.35,2.77C186.89,219.11,183.78,236.47,184.12,236.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.12,236.47l8.17-.08a7.91,7.91,0,0,0,3.42-.54,6.21,6.21,0,0,0,2.79-3.49c1.16-3,1.26-6.22,1.71-9.36s1.41-6.44,3.79-8.55c-4.34.58-12-.78-15.35,2.77C186.89,219.11,183.78,236.47,184.12,236.47Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.1,224.33h0c-.47.13-.78,1.8-.68,2.28l.46.82.93,4,3.12-1.72-2.81-5A.92.92,0,0,0,198.1,224.33Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.63,219.92c-7.3,1.67-18.1,24.42-18.1,24.42l14.65,10a163.67,163.67,0,0,0,11.4-18.85C139.91,226.43,135.09,218.21,127.63,219.92Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.29,220.47c-.84-1.83-1.75-3.92.14-4.57,2.09-.72,13.53-1.46,17.47-.11a4.06,4.06,0,0,1,2.85,5l0,.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.14,233.06l-10.41,19.6,2.45,1.68s4.72-6.57,8-12.25Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,229.93c1.58,8-2.11,27-2.07,58H128.31c-.27-6.26,4.29-21.1-1.38-50.66-.18-1-.26-17.15.7-17.32a110.83,110.83,0,0,1,12.18-1.44,153.7,153.7,0,0,1,17.7,0c2.41.25,6.2,1.74,8.6,2.6C169.84,222.43,171.24,226,172,229.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,237.88c1.08,6.57,5.39,15.25,9.68,20.35.17-3.73.55-7.63.54-10.62Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,228c-1,7.37,13.5,26.18,13.5,26.18l14.59-10s-4.05-10.37-10.86-17.17C167.5,219.23,159.17,220,158,228Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.72 391.13 213.5 391.13 215.27 373.1 207.49 373.1 205.72 391.13",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.15 374.19 214.25 383.48 206.46 383.48 207.37 374.19 215.15 374.19",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.03 391.13 182.81 391.13 186.72 373.1 178.94 373.1 175.03 391.13",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "178.77 374.06 186.55 374.06 184.53 383.35 176.75 383.35 178.77 374.06"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M213.94,387.63h-8.49a.76.76,0,0,0-.67.7l-1.54,8.9a1.52,1.52,0,0,0,.84,1.76.9.9,0,0,0,.28,0c3.06-.06,7.49-.3,11.34-.3,4.51,0,8.4.31,13.68.31,3.2,0,4.09-4.18,2.75-4.55-6.09-1.72-11.06-1.9-16.32-6.11A3,3,0,0,0,213.94,387.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,390.52c1,0,2-.14,2.29-.59a.71.71,0,0,0,0-.81,1,1,0,0,0-.58-.43c-1.3-.35-4,1.2-4.13,1.27a.17.17,0,0,0-.09.19.18.18,0,0,0,.14.15A12.59,12.59,0,0,0,220.12,390.52Zm1.24-1.51h.35a.54.54,0,0,1,.36.26c.13.23.09.34,0,.4-.36.51-2.33.52-3.78.31A8.75,8.75,0,0,1,221.36,389Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.77,390.3h.08c.94-.42,2.8-2.1,2.65-3,0-.21-.18-.46-.68-.52a1.4,1.4,0,0,0-1,.32c-1,.81-1.2,2.91-1.21,3a.18.18,0,0,0,.07.17A.16.16,0,0,0,217.77,390.3Zm1.9-3.15h.11c.33,0,.35.17.36.21.09.53-1.18,1.85-2.14,2.42a4.33,4.33,0,0,1,1-2.39A1.1,1.1,0,0,1,219.67,387.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.36,387.63h-8.74a.75.75,0,0,0-.66.7l-1.54,8.9a1.54,1.54,0,0,0,.89,1.77,1.07,1.07,0,0,0,.25,0c3.05-.06,4.54-.3,8.38-.3,2.37,0,5.4.31,8.67.31s3.69-4.18,2.35-4.55c-6-1.7-6.41-4-8.33-6.28A1.65,1.65,0,0,0,183.36,387.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.93,391.51a2.47,2.47,0,0,0,1.87-.51.74.74,0,0,0,0-.87.85.85,0,0,0-.58-.43c-1.14-.27-3.29,1.2-3.38,1.26a.21.21,0,0,0-.08.19.17.17,0,0,0,.14.14A9.28,9.28,0,0,0,187.93,391.51Zm1-1.48h.22a.5.5,0,0,1,.34.24c.17.31.07.43,0,.48-.33.43-1.92.44-3.09.25a6.12,6.12,0,0,1,2.51-1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,391.3H186c.81-.44,2.37-2.14,2.2-3a.6.6,0,0,0-.59-.49,1.06,1.06,0,0,0-.78.24c-.9.74-1.09,3-1.1,3.08a.19.19,0,0,0,.09.17Zm1.57-3.15h.08c.24,0,.26.14.27.19.1.51-.9,1.8-1.7,2.41a4.55,4.55,0,0,1,.92-2.44.67.67,0,0,1,.43-.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.46,287.91s36.85,15.22,44.47,26.91c-4.53,29.74-12.66,63.62-12.66,63.62H175.41A273.51,273.51,0,0,1,179,334.68c2-36.35-63.42,1.26-50.71-46.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.94,313a69,69,0,0,0-7.7.89l-8.07,1.24a121.34,121.34,0,0,0,13.15,9.62c2.79,1.77,5.83,3.47,9.12,3.48,3.7,0,13.74-4.74,12.08-9.67S187.14,312.82,182.94,313Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.94,287.91S204,292.31,222.78,303c5.78,3.29,5,13.86,4.82,20.82A164.31,164.31,0,0,1,217,378.44H205.42s.59-18.87.2-49.32c-.12-9.13-18.55-12.14-36.56-13.2a41,41,0,0,1-35.24-25.07l-1.23-2.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.81,375.34c.06,0-.75,5.47-.75,5.47h-16l-.44-4.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.61,375.34c.06,0-1.47,5.47-1.47,5.47h-16l.29-4.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.62 315.51 136.15 400.02 134.08 399.73 142.93 314.87 147.62 315.51",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.21 318.54 136.15 400.02 134.08 399.73 142.55 318.52 147.21 318.54",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.94,318.53h-65a7.42,7.42,0,0,1,7.42-7.42h50.16a7.42,7.42,0,0,1,7.42,7.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.94,318.53h-65a7.42,7.42,0,0,1,7.42-7.42h50.16a7.42,7.42,0,0,1,7.42,7.42Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.95 318.52 116.15 400.69 118.25 400.69 130.68 318.52 125.95 318.52",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.93 318.52 194.73 400.69 192.63 400.69 180.21 318.52 184.93 318.52",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.93 318.52 194.73 400.69 192.63 400.69 180.21 318.52 184.93 318.52",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.82 318.52 172.01 400.69 169.92 400.69 167.09 318.52 171.82 318.52",
    style: {
      fill: "#407BFF"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroimg);
export default __webpack_public_path__ + "static/media/heroimg.339ebad21a1512155f142eb9ff67c8b8.svg";
export { ForwardRef as ReactComponent };